import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";

import RayLeftBg from "../../../../../../assets/images/coach-metrics/ray-left-bg.svg";
import RayRightBg from "../../../../../../assets/images/coach-metrics/ray-right-bg.svg";

const cardBgStyles = (color1: string, color2: string) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    ${color1} 0%,
    ${color2} 136.67%
  );
`;
const iconStyles = (bgColor: string) => `
  background: ${bgColor};
  height: 36px;
  width: 36px;
  display: flex;
  padding: 8px;
  border-radius: 50%;
`;

const valueColor = (textColor: string) => `
  color: ${textColor};
`;
export const CPDashboardCoachMetricsCardWrapper = styled.div`
  .coach-metrics-data-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    padding: 12px;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
  }

  .coach-metrics-card-bg-caseload_vs_engagement {
    ${cardBgStyles(
      COLORS.cirrus_coach_metrics_caseloads_vs_engagement,
      COLORS.cirrus_coach_metrics_caseloads_vs_engagement_2,
    )}
  }
  .coach-metrics-card-bg-average_time_spent {
    ${cardBgStyles(
      COLORS.cirrus_coach_metrics_average_time_spent,
      COLORS.cirrus_coach_metrics_average_time_spent_2,
    )}
  }
  .coach-metrics-card-bg-coach_activities {
    ${cardBgStyles(
      COLORS.cirrus_coach_metrics_coach_activities,
      COLORS.cirrus_coach_metrics_coach_activities_2,
    )}
  }
  .coach-metrics-card-bg-participants_landed {
    ${cardBgStyles(
      COLORS.cirrus_coach_metrics_participants_landed,
      COLORS.cirrus_coach_metrics_participants_landed_2,
    )}
  }

  .coach-metrics-card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-image: url(${RayLeftBg}), url(${RayRightBg});
    background-position:
      bottom center,
      bottom -15px right 0px;
    background-repeat: no-repeat, no-repeat;
    background-size: contain, contain;
  }

  .coach-metrics-card-icon {
    &-caseload_vs_engagement {
      ${iconStyles(COLORS.cirrus_coach_metrics_caseloads_vs_engagement_circle)}
      color: ${COLORS.cirrus_white};
    }

    &-average_time_spent {
      ${iconStyles(COLORS.cirrus_coach_metrics_average_time_spent_circle)}
      color: ${COLORS.cirrus_white};
    }

    &-coach_activities {
      ${iconStyles(COLORS.cirrus_coach_metrics_coach_activities_circle)}
      color: ${COLORS.cirrus_white};
    }

    &-participants_landed {
      ${iconStyles(COLORS.cirrus_coach_metrics_participants_landed_circle)}
      color: ${COLORS.cirrus_white};
    }
  }

  .coach-metrics-card-header {
    color: ${COLORS.cirrus_white};
  }

  .coach-metrics-card-label-caseload_vs_engagement {
    ${valueColor(COLORS.cirrus_coach_metrics_caseloads_vs_engagement_value)};
  }
  .coach-metrics-card-label-average_time_spent {
    ${valueColor(COLORS.cirrus_coach_metrics_average_time_spent_value)};
  }
  .coach-metrics-card-label-coach_activities {
    ${valueColor(COLORS.cirrus_coach_metrics_coach_activities_value)};
  }
  .coach-metrics-card-label-participants_landed {
    ${valueColor(COLORS.cirrus_coach_metrics_participants_landed_value)};
  }

  .coach-metrics-card-value {
    color: ${COLORS.cirrus_white};
  }

  .coach-metrics-card {
    position: relative;
    border-radius: 8px;
    cursor: pointer;
    height: 146px;
    width: 300px;

    ${responsive.MOBILE`
      width: 100%;
    `}
  }

  .coach-metrics-data-container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .coach-metrics-data-container-bottom {
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
`;
